
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farm-intelligence-AI-ML-Analytics",
      function () {
        return require("private-next-pages/farm-intelligence-AI-ML-Analytics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/farm-intelligence-AI-ML-Analytics"])
      });
    }
  